export var createAxiosHttpAdapter = function (axios) {
    var http = {
        get: function (url, headers) { return axios.get(url, { headers: headers }).then(function (req) { return req.data; }); },
        // tslint:disable-next-line:max-line-length
        post: function (url, body, headers, onUploadProgress) { return axios.post(url, body, {
            onUploadProgress: onUploadProgress, headers: headers
        }).then(function (req) { return req.data; }); },
        put: function (url, body, headers) { return axios.put(url, body, { headers: headers }).then(function (req) { return req.data; }); },
        delete: function (url, headers) { return axios.delete(url, { headers: headers }).then(function (req) { return req.data; }); }
    };
    return http;
};
//# sourceMappingURL=axios-adapter.js.map